module.exports = __webpack_public_path__ + "img/img-7.4d5af8ff.png";